import { linksOf } from "../../../services/cpln";
import { InternalLink } from "../components/InternalLink";
import { TableColumn } from "../types";

const nameDescriptionDefault = { id: "name", label: "Name" };
export function ReleaseNameDescriptionColumn<TData extends { name: string; description: string; kind: string }>(
  column: Partial<TableColumn<TData>> = nameDescriptionDefault,
) {
  const preset: TableColumn<TData> = {
    ...nameDescriptionDefault,
    enableResize: true,
    enableSort: true,
    size: 200,
    cell: (p) => {
      const item = p.row.original;
      let selfLink = linksOf(item as any).self || "";

      const isSame = item.name === item.description;

      return (
        <div className="flex flex-col justify-center" style={{ height: 56 }}>
          <InternalLink label={item.name} to={`/console${selfLink}`} />
          {isSame ? null : <span className="text-sm description">{item.description}</span>}
        </div>
      );
    },
  };
  return Object.assign(preset, column);
}
